import React from 'react'
import moment from 'moment'
import ServiceKeyValueCard, {
    TServiceKeyValueItem,
} from './ServiceKeyValueCard'
import { TNormalizedService } from '../../types/serviceView'

type TProps = {
    service: TNormalizedService
    className?: string
    extraItems?: TServiceKeyValueItem[]
}

const DISPLAY_PLACEHOLDER = '--'
const NOT_AVAILABLE = 'N/A'

const asDisplayValue = (
    value: string | number | undefined,
    fallback = DISPLAY_PLACEHOLDER
): string => {
    if (value === null || value === undefined) {
        return fallback
    }

    const stringValue = String(value).trim()
    return stringValue || fallback
}

const asDateValue = (value?: string): string => {
    if (!value) {
        return NOT_AVAILABLE
    }

    const parsed = moment(value)
    return parsed.isValid() ? parsed.format('DD/MM/YYYY') : NOT_AVAILABLE
}

const ServiceBasicView: React.FC<TProps> = ({
    service,
    className = '',
    extraItems = [],
}) => {
    const items: TServiceKeyValueItem[] = [
        {
            label: 'Service',
            value: asDisplayValue(service.name),
        },
        {
            label: 'Product Code',
            value: asDisplayValue(service.productCode),
        },
        {
            label: 'Order Number',
            value: asDisplayValue(service.orderNumber, NOT_AVAILABLE),
        },
        {
            label: 'Service Group',
            value: asDisplayValue(service.groupName, NOT_AVAILABLE),
        },
        {
            label: 'Active Since',
            value: asDateValue(service.goLiveDate),
        },
        ...extraItems,
    ]

    return (
        <div className={className} data-testid="service-basic-view">
            <ServiceKeyValueCard title="Details" items={items} />
        </div>
    )
}

export default ServiceBasicView
